import InboxButton from './InboxButton';

export default InboxButton;
